// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Asset_Icon__3T-l2","Text":"Asset_Text__36af3"};